import Seo from "../components/Seo";
import Section from "../components/ui-custom/Section";
import CTA from "../components/sections/CTA";
import PageHeader from "../components/ui-custom/PageHeader";
import { Reveal } from "../components/ui-custom/Reveal";
import TiltCard from "../components/ui-custom/TiltCard";
import Icon from "../components/Icon";

const features = [
  { icon: "Webhook", title: "REST APIs", desc: "Clean, well-documented REST endpoints for every service." },
  { icon: "FlaskConical", title: "Sandbox", desc: "Test safely in a full sandbox before going live." },
  { icon: "Bell", title: "Webhooks", desc: "Real-time event callbacks for transactions and status." },
  { icon: "KeyRound", title: "Secure Keys", desc: "Token-based auth with granular access controls." },
];

const snippet = `POST /v1/pan/apply
Authorization: Bearer <your_api_key>
Content-Type: application/json

{
  "type": "instant",
  "aadhaar": "XXXX-XXXX-1234",
  "mobile": "98765XXXXX"
}`;

export default function Api() {
  return (
    <>
      <Seo title="API Platform" description="Integrate utipanagecy PAN, recharge, banking and bill services into your own apps via secure REST APIs." />
      <PageHeader eyebrow="Developers" title="Build with the utipanagecy API" sub="Integrate PAN, recharge, banking and bill payments into your own product." />
      <Section testId="api-page">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
          <div className="grid gap-4 sm:grid-cols-2">
            {features.map((f, i) => (
              <Reveal key={f.title} delay={(i % 2) * 0.08}>
                <TiltCard className="h-full p-6" data-testid={`api-feature-${i}`}>
                  <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-soft text-brand">
                    <Icon name={f.icon} size={20} />
                  </div>
                  <h3 className="mt-4 font-semibold text-slate-900">{f.title}</h3>
                  <p className="mt-1.5 text-sm text-slate-500">{f.desc}</p>
                </TiltCard>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.15}>
            <div className="overflow-hidden rounded-2xl bg-slate-900 shadow-xl" data-testid="api-snippet">
              <div className="flex items-center gap-2 border-b border-white/10 px-5 py-3">
                <span className="h-3 w-3 rounded-full bg-red-400" />
                <span className="h-3 w-3 rounded-full bg-amber-400" />
                <span className="h-3 w-3 rounded-full bg-emerald-400" />
                <span className="ml-2 text-xs text-slate-400">apply-pan.sh</span>
              </div>
              <pre className="overflow-x-auto p-5 text-xs leading-relaxed text-emerald-300"><code>{snippet}</code></pre>
            </div>
          </Reveal>
        </div>
      </Section>
      <CTA />
    </>
  );
}
